import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {MatDrawer} from '@angular/material/sidenav';
import {CommonModule} from '@angular/common';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTabsModule} from '@angular/material/tabs';
import {MatMenuModule} from '@angular/material/menu';
import {ChatService} from '../../core/services/chat.service';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {FieldForm} from '../../shared/form-dialog-generico/form-dialog-generico.component';
import {MatButtonModule} from '@angular/material/button';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {MatInput} from '@angular/material/input';
import {debounceTime, distinctUntilChanged, first, firstValueFrom, Subject, takeUntil, Subscription, switchMap} from 'rxjs';
import {CrudService} from '../../core/services/crud.service';
import {AdminItemChatComponent} from './admin-item-chat/admin-item-chat.component';
import {MatBadge} from '@angular/material/badge';
import {ChatComponent} from './chat/chat.component';
import {GenericoService} from '../../core/services/generico.service';

@Component({
  selector: 'app-administrador-chats',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatTabsModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatAutocomplete,
    MatAutocompleteTrigger,
    MatInput,
    MatOption,
    AdminItemChatComponent,
    MatBadge,
    ChatComponent,
  ],
  templateUrl: './administrador-chats.component.html',
  styleUrl: './administrador-chats.component.scss'
})
export class AdministradorChatsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() criteriaSearch = 'filtroGeneral';
  @Input() max: number = 15
  @Output() selectedChat = new EventEmitter();
  @Output() closeAdminChat = new EventEmitter()

  private destroyed = false;
  private destroyed$ = new Subject<void>();
  ngOnDestroy(): void { this.destroyed = true; this.destroyed$.next(); this.destroyed$.complete(); this.observableFiltro?.unsubscribe(); }

  tooltipContent = `También puedes buscar por: \n\n-Nombre de usuario \n-Teléfono de usuario \n-ID del negocio`;
  myChats: any[] = [];
  allChats: any[] = [];
  public viewChats: any = [];

  fieldForms!: FieldForm[];

  form!: FormGroup;
  observableFiltro: Subscription | null | undefined = null;
  options: any[] = [];

  notificacionesMisChats = 0;
  notificacionesOtrosChats = 0;

  subDrawerOpened = true;

  constructor(
    private chatService: ChatService,
    private fb: FormBuilder,
    private crudService: CrudService,
    private genericoService: GenericoService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.viewChats.length) {
      this.subDrawerOpened = !this.subDrawerOpened
    }
  }

  ngOnInit(): void {
    this.otrosChats();
    this.misChats();
    // this.getSelectedChats();

    this.form = this.fb.group({
      paramFilter: new FormControl(''),
      param: new FormControl('')
    })

    this.observableFiltro = this.form.get('paramFilter')?.valueChanges.pipe(
      debounceTime(300), // Espera 300 ms después de que el usuario deja de escribir
      distinctUntilChanged(), // Solo emite si el valor ha cambiado
      switchMap((value: any) => {
        if (value) {
          return this.crudService.list({
            [this.criteriaSearch]: value,
            max: this.max,
            order: 'asc'
          }, 'getUsers');
        }
        return [];

      }) // Cambia esto por la URL de tu servidor
    ).subscribe(({data}: any) => {
      this.options = data;
      // if (this.options.length === 1 && this.autoSetUniqueValue) {
      //   this.setUniqueValue();
      // }
    });

    this.chatService.selectedChatOpen$.pipe(takeUntil(this.destroyed$)).subscribe(chats => {
      if (this.viewChats.length < 1 && !this.subDrawerOpened) {
        this.subDrawerOpened = !this.subDrawerOpened
      }
    });

  }

  // getSelectedChats(): void {
  //   this.viewChats = [];
  //   this.chatService.returnSelectedChats().subscribe(response => {
  //     this.viewChats = response;
  //     this.selectedChat.emit(this.viewChats)
  //   });
  // }

  // open() {
  //   this.otrosChats();
  //   this.misChats();
  //   this.adminChatsDrawer.open();
  // }

  otrosChats() {
    this.chatService.returnAllChats().pipe(takeUntil(this.destroyed$)).subscribe((response) => {
      this.allChats = response;
      this.notificacionesOtrosChats = 0;
      this.allChats.forEach((chat: any) => {
        if (chat.notificacionAgente) {
          this.notificacionesOtrosChats++;
        }
      });
      // this.buttons[0].badge = notificaciones;
      this.chatService.setNotficaciones(this.notificacionesOtrosChats, 0);
    });
  }

  misChats() {
    this.chatService.returnMyChats().pipe(takeUntil(this.destroyed$)).subscribe((response: any) => {
      this.myChats = response;
      this.notificacionesMisChats = 0;
      this.myChats.forEach((chat: any) => {
        if (chat.notificacionAgente) {
          this.notificacionesMisChats++;
        }
      });
      // this.buttons[1].badge = notificaciones;
      this.chatService.setNotficaciones(this.notificacionesMisChats, 1);
    });
  }

  onOptionSelected(option: any, nameForm: FormGroup, nameInput: string, relatedField: any) {
    const selectedId = option.id;
    nameForm.get(relatedField)?.setValue(selectedId)
    nameForm.get(nameInput)?.setValue(`${option.id} - ${option.nombre} ${option?.apeidoPaterno} ${option?.apeidoMaterno}`)

    this.chatService
      .getUserId(selectedId)
      .pipe(first())
      .subscribe((response) => {
        this.newChatView(response.user);
        this.clearParamFilter();
      });
  }

  async newChatView(data: any) {

    const isConfirmed = await this.genericoService.confirmDialog(
      `¿Seguro que desea tomar el chat de <b>${data.nombre} ${data.apeidoPaterno} ${data.apeidoMaterno}</b> del negocio <b>${data.negocio.id} - ${data.negocio.nombre}<b>`
    );
    if (!isConfirmed || this.destroyed) {
      return;
    }

    const payload = {
      idUser: data.id,
    };

    this.takeChatAgent(payload).then((response: any) => {
      if (this.destroyed) return;
      // Server confirms assignment in this single operation.
      {
        this.chatService.newChatView({
          readMessages: true,
          ...response.chat,
          idChat: response.chat.id,
        });
      }
    }).catch(() => { if (!this.destroyed) this.genericoService.errorDialog('No se pudo tomar el chat. Verifica si otro agente lo está atendiendo.'); });
  }

  async takeChatAgent(payload: any) {
    if (this.destroyed) throw new Error('Vista cerrada');
    return firstValueFrom(this.chatService.takeChatAgent(payload).pipe(first(), takeUntil(this.destroyed$)));
  }

  async takeChat(payload: any) { return firstValueFrom(this.chatService.takeChat(payload).pipe(first(), takeUntil(this.destroyed$))); }

  // Opcional: función para limpiar el control
  clearParamFilter() {
    this.form.get('paramFilter')?.setValue('');
  }

  viewChat(chat: any): void {
    this.selectedChat.emit(chat);
  }

  abrirSubDrawer() {
    if (this.viewChats.length < 1) {
      this.genericoService.openSnackBar(
        'No puedes minimizar el administrador de chats, debes abrir o al menos un chat.',
        'Aceptar',
        'snack-bar-error', () => {
        });
      return
    }
    this.subDrawerOpened = !this.subDrawerOpened
  }

  closeAdmin() {
      this.closeAdminChat.emit()
  }
}
